import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem'

const useStyles = makeStyles(theme => ({
 
  link:{
    color: theme.palette.text.secondary,
    width: '100%',
  },
  title: {
    display: 'flex',
    align:"left",
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  
}));

const MenuItem = ({ itemName, text }) => {
  let classes = useStyles();

  const [anchorTarget, setAnchorTarget] = useState(null);

  useEffect(() => {
    setAnchorTarget(document.getElementById(itemName));
  }, [itemName]);


  const handleClick = event => {
    event.preventDefault();
    anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
       <ListItem display='inlineBlock'>
        <Typography  variant="h4" noWrap color={"textPrimary"}>
             <a href={`#${itemName}`} 
              onClick={handleClick}
              className={classes.link}
              ariaLabel={`Scroll to ${itemName}`}>
              {text}
              </a>
       </Typography>
       </ListItem>
    
  );
};

export default MenuItem;